import React, {useEffect, useState, useCallback} from 'react';
import Select from 'react-select';
import { Col, Label } from 'reactstrap';
import api from '../../services/api'
import './style.scss';


export default ({ name, label, required, options, remote, placeholder, sizeSm, sizeMd, sizeLg, _handleChangeAutocomplete, value, selectFirstIfOnlyOne }) => {
    sizeSm = !!sizeSm ? sizeSm : 0;
    sizeMd = !!sizeMd ? sizeMd : 0;
    sizeLg = !!sizeLg ? sizeLg : 0;


    const parseItem = p => ({ value: p.value, label: p.text });

    const [op, setOp] = useState([])
    const [inputValue, setInputValue] = useState(value);


    const onFetchOptions = useCallback((options) => {

      if (!options || !options.length) return;
      if (!inputValue && !!selectFirstIfOnlyOne && options.length === 1) {
          const newValue = !!remote.value ? options[0][remote.value] : options[0].value;
          setInputValue(newValue);
          _handleChangeAutocomplete(name, newValue);
      }
  },[_handleChangeAutocomplete,setInputValue,inputValue,remote,name, selectFirstIfOnlyOne]);

    const fetchOptions =  useCallback(async () => {
      let promisse = null;
      let client = await api(remote.service);
      if (remote.method.toUpperCase() === "POST") {
          promisse = client.post(remote.path, remote.params);
      } else {
          promisse = client.get(remote.path, {params: remote.params});
      }

      promisse.then(res => {
          const data = res.data.map( parseItem );
          onFetchOptions(data);
          setOp(data);
      });
   },[remote,onFetchOptions]) ;

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    useEffect(() => {
        if(!!remote){
            fetchOptions();
        }
    }, [remote, fetchOptions])



    const onChange = (e) => {
        const value = !!e ? e.value : null;
        _handleChangeAutocomplete(name, value);
    };

    const displayFormat = (item) => {
        if(!!remote && remote.display) {
            let text = remote.display;
            Object.keys(item).forEach(prop => {
                let exp = new RegExp(`{${prop}}`, "g");
                text = text.replace(exp, item[prop])
            })
            return <span className="Select-value-label">{text}</span>
        }
        return <span className="Select-value-label">{item.label}</span>
    }




    return (
        <React.Fragment>
            <Col sm={sizeSm} md={sizeMd} lg={sizeLg}>
                <Label>{label}</Label>
                <Select
                    valueRenderer={displayFormat}
                    optionRenderer={displayFormat}
                    className="form-control-autocomplete"
                    value={inputValue}
                    placeholder={placeholder}
                    onChange={onChange}
                    options={options ? options : op}/>
            </Col>
            </React.Fragment>
    )
};
